import {throttle} from "throttle-debounce";
import Modernizr from 'modernizr';


function ContentAndMediaVideo() {
		$('body').on('click', '.js-play-pause', function(e) {
			e.preventDefault();
		});

		function isScrolledIntoView(elem)
		{
			let docViewTop = $(window).scrollTop();
			let docViewBottom = docViewTop + $(window).height();

			let elemTop = $(elem).offset().top;
			let elemBottom = elemTop + $(elem).height();

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}



		if (Modernizr.mobilesafari || (Modernizr.coarsepointer && $(window).width() < 768)) {
			let $playPause = $('.js-play-pause');
			$playPause.each(function() {
				let $this = $(this);
				let player:any = $this.find('.content-and-media__video').get(0);
				let $parent = $this.parents('.content-and-media__media');

				if(player) {
					player.play();
					player.pause();
					player.currentTime = 0;
					player.addEventListener('ended', function(){
						player.pause();
						$parent.removeClass('state-play');
					});
				}
			});

			$(window).on('scroll', (throttle as any)(20, false, (event) => {
				$('.js-play-pause').each(function() {
					let $this = $(this);
					let $parent = $this.parents('.content-and-media__media');
					let player:any = $this.find('.content-and-media__video').get(0);

					if(isScrolledIntoView($this.find('.content-and-media__video'))){
						if(!$parent.hasClass('state-play')) {
							player.currentTime = 0;
							player.play();
							$parent.addClass('state-play');
						}
					} else {
						player.pause();
						$parent.removeClass('state-play');
					}
				});
			}));
		}
}

export function init() {
	ContentAndMediaVideo();
}
